module.exports = __webpack_public_path__ + "assets/pay-method-nal.c3e34072.svg";